import { ResourceName } from "../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { CampaignTerminalsResponse, LoadCampaignTerminalsRequest } from "./types";

export const campaignTerminalsApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadCampaignTerminals: builder.query<CampaignTerminalsResponse, LoadCampaignTerminalsRequest>({
            providesTags: ["mainCache"],
            query: ({ dataGroupCode, campaignId }) => ({
                url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/${ResourceName.CAMPAIGNS}/${campaignId}/${ResourceName.TERMINALS}`,
                method: "GET",
            }),
        }),
    }),
});

export const { useLoadCampaignTerminalsQuery } = campaignTerminalsApi;
